<template>
  <div id="mtn_world" class="gray-gradient">
    <navbar :data="3"/>
    <intro/>
    <popular-bundles/>
    <random-offers/>
    <MtnApps/>
    <special-services/>
    <Footer/>
  </div>
</template>

<script>
import Navbar from '../Navbar'
import Intro from '../Intro'
import PopularBundles from '../PopularBundles'
import RandomOffers from '../RandomOffers'
import MtnApps from '../MtnApps'
import SpecialServices from '../SpecialServices'
import Footer from '../../components/core/Footer'
export default {
  name: 'MtnWorld',
  components: { Footer, SpecialServices, MtnApps, RandomOffers, PopularBundles, Intro, Navbar },
  data () {
    return {
    }
  },
  created () {
    this.$store.state.activeNav = 3
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="scss">
@import "src/assets/sass/main";
</style>
